import React, { Component } from 'react';
import classNames from 'classnames';
import { uniqueId, includes, get, isFunction, isNumber, upperFirst, camelCase } from 'lodash';
import { addAnchorTagToUrl, anchorScroll, isSSR, validate, mergeStyles } from 'wix-rich-content-common';
import { initCustomElement, Image as Image$1 } from '@wix/image';
import { PluginContainerData_Alignment, PluginContainerData_Width_Type, Node_Type } from 'ricos-schema';
import pluginImageSchema from 'wix-rich-content-common/dist/statics/schemas/plugin-image.schema.json';

const IMAGE_TYPE = "wix-draft-plugin-image";
const IMAGE_TYPE_LEGACY = "IMAGE";

const DEFAULTS = Object.freeze({
  config: {
    alignment: "center",
    size: "content",
    showTitle: true,
    showDescription: true
  }
});
Object.freeze({
  containerData: {
    alignment: PluginContainerData_Alignment.CENTER,
    width: {
      size: PluginContainerData_Width_Type.CONTENT
    },
    textWrap: true
  }
});
({
  settings: `${Node_Type.IMAGE}.settings`,
  imageEditor: `${Node_Type.IMAGE}.imageEditor`
});
({
  size: `${Node_Type.IMAGE}.size`,
  alignment: `${Node_Type.IMAGE}.alignment`
});

var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
const expand = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues$3({ viewBox: "0 0 19 19", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M15.071 8.371V4.585l-4.355 4.356a.2.2 0 0 1-.283 0l-.374-.374a.2.2 0 0 1 0-.283l4.356-4.355h-3.786a.2.2 0 0 1-.2-.2V3.2c0-.11.09-.2.2-.2H16v5.371a.2.2 0 0 1-.2.2h-.529a.2.2 0 0 1-.2-.2zm-6.5 6.9v.529a.2.2 0 0 1-.2.2H3v-5.371c0-.11.09-.2.2-.2h.529c.11 0 .2.09.2.2v3.786l4.355-4.356a.2.2 0 0 1 .283 0l.374.374a.2.2 0 0 1 0 .283L4.585 15.07h3.786c.11 0 .2.09.2.2z",
    fill: "#000",
    fillRule: "nonzero"
  }
));

var styles$1 = {"fontElementMap":"_6t07w","inPluginInput":"Mk4LK"};

class InPluginInput extends Component {
  constructor() {
    super(...arguments);
    this.handleFocus = (e) => {
      e.stopPropagation();
      this.props.setFocusToBlock();
      this.props.setInPluginEditingMode(true);
    };
    this.handleBlur = () => this.props.setInPluginEditingMode(false);
    this.handleKeyPress = (e) => {
      const { setFocusToBlock, value } = this.props;
      if (e.key === "Enter" && setFocusToBlock && value !== "") {
        this.handleBlur();
        setFocusToBlock();
      }
    };
    this.onChange = (e) => {
      var _a, _b;
      return (_b = (_a = this.props).onChange) == null ? void 0 : _b.call(_a, e.target.value);
    };
  }
  render() {
    const className = classNames(styles$1.inPluginInput, this.props.className);
    return /* @__PURE__ */ React.createElement(
      "textarea",
      {
        className,
        value: this.props.value,
        onChange: this.onChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onKeyPress: this.handleKeyPress,
        dir: "auto",
        rows: 1
      }
    );
  }
}
InPluginInput.defaultProps = {
  setInPluginEditingMode: () => false,
  setFocusToBlock: () => false
};

var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
initCustomElement();
const IMAGE_FALLBACK_WIDTH = 300;
const getImageSrc = (src, customGetImageUrl) => {
  if (typeof src === "object") {
    if (src.source) {
      if (src.source === "static") {
        if (src.url) {
          return src.url;
        } else {
          console.error("must provide src url when using static image source!", src);
        }
      } else if (src.source === "custom") {
        if (customGetImageUrl) {
          return customGetImageUrl({ file_name: src.file_name });
        } else {
          console.error("must provide getImageUrl helper when using custom image source!", src);
        }
      }
    } else if (src.file_name) {
      return src.file_name;
    }
  }
  return src;
};
class WixImage extends React.Component {
  constructor(props) {
    super(props);
    this.handleExpand = (e) => {
      var _a;
      e.preventDefault();
      const {
        settings: { onExpand },
        helpers = {}
      } = this.props;
      (_a = helpers.onViewerAction) == null ? void 0 : _a.call(helpers, IMAGE_TYPE, "Click", "expand_image");
      this.hasExpand() && (onExpand == null ? void 0 : onExpand(this.props.blockKey));
    };
    this.scrollToAnchor = (e) => {
      const {
        componentData: {
          config: { link: { anchor } = {} }
        },
        customAnchorScroll
      } = this.props;
      if (customAnchorScroll) {
        customAnchorScroll(e, anchor);
      } else {
        const anchorString = `viewer-${anchor}`;
        const element = document.getElementById(anchorString);
        addAnchorTagToUrl(anchorString);
        anchorScroll(element);
      }
    };
    this.hasLink = () => {
      var _a, _b, _c;
      return (_c = (_b = (_a = this.props.componentData) == null ? void 0 : _a.config) == null ? void 0 : _b.link) == null ? void 0 : _c.url;
    };
    this.hasAnchor = () => {
      var _a, _b, _c;
      return (_c = (_b = (_a = this.props.componentData) == null ? void 0 : _a.config) == null ? void 0 : _b.link) == null ? void 0 : _c.anchor;
    };
    this.onKeyDown = (e) => {
      if ((e.key === "Enter" || e.key === " ") && !this.props.getInPluginEditingMode) {
        this.handleClick(e);
      }
    };
    this.handleClick = (e) => {
      if (this.hasLink()) {
        return null;
      } else if (this.hasAnchor()) {
        e.preventDefault();
        e.stopPropagation();
        this.scrollToAnchor(e);
      } else {
        this.handleExpand(e);
      }
    };
    this.handleContextMenu = (e) => {
      const {
        componentData: { disableDownload = false }
      } = this.props;
      return disableDownload && e.preventDefault();
    };
    this.hasExpand = () => {
      const { componentData, settings } = this.props;
      let disableExpand = false;
      if (componentData.disableExpand !== void 0) {
        disableExpand = componentData.disableExpand;
      } else if (settings.disableExpand !== void 0) {
        disableExpand = settings.disableExpand;
      }
      return !disableExpand && settings.onExpand;
    };
    this.renderExpandIcon = () => {
      const {
        styles: { expandContainer, expandIcon }
      } = this.props;
      return /* @__PURE__ */ React.createElement("div", { className: expandContainer }, /* @__PURE__ */ React.createElement(expand, { className: expandIcon, onClick: this.handleExpand }));
    };
    this.getImgSize = (imgSrc) => {
      const newImg = new Image();
      newImg.onload = () => this.setState({ dimensions: { width: newImg.width, height: newImg.height } });
      newImg.src = imgSrc;
    };
    this._id = uniqueId("new-image");
  }
  getImageDataUrl() {
    return this.props.dataUrl ? this.props.dataUrl : null;
  }
  renderTitle(data) {
    const config = data.config || {};
    return !!config.showTitle && /* @__PURE__ */ React.createElement("div", { className: classNames(this.props.styles.imageTitle) }, data && data.title || "");
  }
  renderDescription(data) {
    const config = data.config || {};
    return !!config.showDescription && /* @__PURE__ */ React.createElement("div", { className: classNames(this.props.styles.imageDescription) }, data && data.description || "");
  }
  renderCaption(caption) {
    const {
      onCaptionChange,
      setFocusToBlock,
      setInPluginEditingMode,
      styles: { imageCaption, link }
    } = this.props;
    const classes = classNames(imageCaption, this.hasLink() && link);
    return onCaptionChange ? /* @__PURE__ */ React.createElement(
      InPluginInput,
      {
        setInPluginEditingMode,
        className: classes,
        value: caption,
        onChange: onCaptionChange,
        setFocusToBlock
      }
    ) : /* @__PURE__ */ React.createElement("span", { dir: "auto", className: classes }, caption);
  }
  shouldRenderCaption() {
    var _a;
    const { getInPluginEditingMode, settings, componentData, defaultCaption } = this.props;
    const caption = (_a = componentData.metadata) == null ? void 0 : _a.caption;
    if (includes(get(settings, "toolbar.hidden"), "settings")) {
      return false;
    }
    if (caption === void 0 || caption === "" && !(getInPluginEditingMode == null ? void 0 : getInPluginEditingMode()) || caption === defaultCaption) {
      return false;
    }
    const data = componentData || DEFAULTS;
    if (data.config.size === "original" && data.src && data.src.width) {
      return data.src.width >= 350;
    }
    return true;
  }
  // eslint-disable-next-line complexity
  render() {
    var _a, _b, _c, _d, _e;
    const {
      componentData,
      className,
      settings,
      setComponentUrl,
      helpers,
      getInPluginEditingMode,
      styles,
      isMobile,
      seoMode,
      accessibilityProps
    } = this.props;
    const data = componentData || DEFAULTS;
    let { metadata, config: { alignment, width, size } = {} } = componentData;
    if (!metadata) {
      metadata = {};
    }
    const itemClassName = classNames(styles.imageWrapper, styles.imageRatio, className, {
      [styles.pointer]: this.hasExpand()
    });
    const imageSrc = this.getImageDataUrl() || getImageSrc(data.src, helpers == null ? void 0 : helpers.getImageUrl);
    let imageProps = {};
    if (data.src && settings && settings.imageProps) {
      imageProps = isFunction(settings.imageProps) ? settings.imageProps(data.src) : settings.imageProps;
    }
    const socialAttrs = {};
    ["data-pin-nopin", "data-pin-url", "data-pin-media"].forEach(
      (attr) => imageProps[attr] && (socialAttrs[attr] = imageProps[attr])
    );
    setComponentUrl == null ? void 0 : setComponentUrl(imageSrc);
    const isEditor = getInPluginEditingMode;
    const usePredefinedWidth = (alignment === "left" || alignment === "right") && !width && size !== "small" && size !== "original" && !isMobile;
    const dim = {
      width: ((_a = data.src) == null ? void 0 : _a.width) || data.width || ((_b = this.state) == null ? void 0 : _b.dimensions.width),
      height: ((_c = data.src) == null ? void 0 : _c.height) || data.height || ((_d = this.state) == null ? void 0 : _d.dimensions.height)
    };
    const isDimensionsExists = dim.width && dim.height;
    if (!isDimensionsExists && !isSSR()) {
      this.getImgSize(imageSrc);
    }
    const customWidthStyle = size === "original" || isMobile && size === "inline" && data.config.width && data.config.width > 150 ? { width: ((_e = data.src) == null ? void 0 : _e.width) + "px", maxWidth: "100%" } : {};
    return /* @__PURE__ */ React.createElement(
      "div",
      __spreadValues$2({
        "data-hook": "imageViewer",
        className: styles.imageContainer,
        onContextMenu: this.handleContextMenu,
        onKeyDown: this.onKeyDown
      }, accessibilityProps),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: itemClassName,
          id: this._id,
          "aria-label": metadata.alt,
          onClick: this.handleClick,
          onKeyDown: this.onKeyDown,
          style: __spreadValues$2(__spreadValues$2({
            "--dim-height": dim.height,
            "--dim-width": dim.width
          }, usePredefinedWidth && { width: IMAGE_FALLBACK_WIDTH + "px" }), customWidthStyle)
        },
        isDimensionsExists && /* @__PURE__ */ React.createElement(
          Image$1,
          __spreadValues$2({
            id: imageSrc,
            containerId: this._id,
            displayMode: "fill",
            width: dim.width,
            height: dim.height,
            uri: imageSrc,
            alt: metadata.alt || "",
            socialAttrs,
            isSEOBot: !!seoMode,
            imageStyles: {
              maxWidth: "100%"
            }
          }, !isEditor && {
            placeholderTransition: seoMode ? void 0 : "blur",
            shouldUseLQIP: !settings.disableTransition
          })
        ),
        this.hasExpand() && this.renderExpandIcon()
      ),
      this.renderTitle(data),
      this.renderDescription(data),
      this.shouldRenderCaption() && this.renderCaption(metadata.caption)
    );
  }
}

var styles = {"fontElementMap":"rmgmv","imageContainer":"Jg78m","expandContainer":"L0kh-","expandIcon":"zfTYS","pointer":"C4iEj","imageWrapper":"m0-n7","imageRatio":"TCFHy","image":"g4Vxx","imageOverlay":"OLynb","imageCaption":"MSffY","imagePreload":"sT8BN","imageHighres":"LUpSR","onlyHighRes":"A2yuP","image_loading":"oVXzZ"};

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ImageViewer = (props) => {
  React.useEffect(() => {
    validate(props.componentData, pluginImageSchema);
  }, [props.componentData]);
  const mergedStyles = mergeStyles({ styles, theme: props.theme });
  const hasLink = () => {
    var _a, _b, _c;
    return (_c = (_b = (_a = props.componentData) == null ? void 0 : _a.config) == null ? void 0 : _b.link) == null ? void 0 : _c.url;
  };
  const hasExpandMode = () => {
    var _a;
    return !((_a = props.componentData) == null ? void 0 : _a.disableExpand);
  };
  const accessibilityProps = hasLink() || hasExpandMode() ? { role: "button", tabIndex: 0 } : {};
  return /* @__PURE__ */ React.createElement(WixImage, __spreadProps(__spreadValues$1({}, props), { styles: mergedStyles, accessibilityProps }));
};

const alignmentClassName = (componentData, theme, styles) => {
  const { alignment, size } = componentData.config || {};
  if (!alignment) {
    return "";
  }
  let align = alignment;
  if (size === "original" && alignment !== "center") {
    const { width } = componentData.src || {};
    if (isNumber(width) && width > 350) {
      align = "center";
    }
  }
  return classNames(styles[`align${upperFirst(align)}`], theme[`align${upperFirst(align)}`]);
};
const sizeClassName = (componentData, theme, styles, isMobile) => {
  const { size } = componentData.config || {};
  if (!size || isMobile && size === "original") {
    return "";
  }
  return size === "fullWidth" ? classNames(styles.sizeFullWidth, theme.sizeFullWidth) : classNames(
    styles[`size${upperFirst(camelCase(size))}`],
    theme[`size${upperFirst(camelCase(size))}`]
  );
};

const imageRenderDescriptor = {
  component: ImageViewer,
  classNameStrategies: {
    size: sizeClassName,
    alignment: alignmentClassName
  }
};
const typeMapper = () => ({
  [IMAGE_TYPE_LEGACY]: imageRenderDescriptor,
  [IMAGE_TYPE]: imageRenderDescriptor
});

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const imageTypeMapper = typeMapper;
const pluginImage = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: IMAGE_TYPE,
    typeMapper
    // nodeViewRenderers,
  };
};

export { IMAGE_TYPE, imageTypeMapper, pluginImage };
//# sourceMappingURL=viewer.js.map

import 'wix-rich-content-plugin-image/dist/es/styles.viewer.min.global.css'